import { render, staticRenderFns } from "./Index.ts.vue?vue&type=template&id=15c450a0"
import script from "./Index.ts.vue?vue&type=script&lang=ts"
export * from "./Index.ts.vue?vue&type=script&lang=ts"
import style0 from "./Index.ts.vue?vue&type=style&index=0&id=15c450a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports